/**
 * Firebase messaging service-worker registration.
 *
 * Registered at bootstrap (main.tsx) regardless of auth state so the SW is
 * installed and controlling before the post-login token registration needs
 * it. Mirrors AIM's `bootstrap/serviceWorkerSetup.ts` minus the alert-audio
 * message plumbing (AIM-only) and the page-side message listener
 * (ONE's lives in `PushNotificationsManager`, where auth context exists).
 */
export function registerPushServiceWorker(): void {
  if (!('serviceWorker' in navigator)) {
    console.warn(
      '[aegix-one push] Service workers unsupported in this browser — no push.',
    );
    return;
  }

  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/firebase-messaging-sw.js')
      .catch((err) => {
        console.error(
          '[aegix-one push] Service worker registration failed:',
          err,
        );
      });
  });
}
